module.exports = __webpack_public_path__ + "img/pending.6fe38adc.svg";